import { form, errors } from '../state'

/**
 * Form verilerini doğrular
 * @param {Object} suggestionData - Doğrulanacak öneri verisi (opsiyonel, form state'i kullanılabilir)
 * @param {String} contentType - İçerik tipi ('IMAGE', 'VIDEO', 'TEXT')
 * @returns {Boolean} Form geçerli mi değil mi
 */
export const validateForm = (suggestionData = null, contentType = null) => {
  // Opsiyonel olarak dışarıdan gelen veriyi kullan, yoksa form state'ini kullan
  const data = suggestionData || form
  let isValid = true
  
  // Hata durumlarını sıfırla
  Object.keys(errors).forEach(key => errors[key] = '')

  // Öneri alanını kontrol et
  if (!data.suggestion?.trim()) {
    errors.suggestion = 'Öneri detayı zorunlu alan'
    isValid = false
  }

  // Görsel URL doğrulama
  if (contentType === 'IMAGE' && data.currentImageUrl) {
    isValid = validateUrl(data.currentImageUrl, 'currentImageUrl') && isValid
  }

  // Video URL doğrulama
  if (contentType === 'VIDEO' && data.currentVideoUrl) {
    isValid = validateUrl(data.currentVideoUrl, 'currentVideoUrl') && isValid
  }

  return isValid
}

/**
 * URL formatını doğrular ve gerekirse düzeltir
 * @param {String} url - Doğrulanacak URL
 * @param {String} fieldName - Form alanı adı ('currentImageUrl' veya 'currentVideoUrl')
 * @returns {Boolean} URL geçerli mi
 */
const validateUrl = (url, fieldName) => {
  try {
    // Geçerli URL mi kontrol et
    new URL(url)
    return true
  } catch (e) {
    // HTTP/HTTPS protokolü eksik olabilir, eklemeyi dene
    try {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        // Geçerli bir URL olup olmadığını kontrol et
        new URL('https://' + url)
        // Geçerliyse, form değerini düzelt
        form[fieldName] = 'https://' + url
        return true
      } else {
        errors[fieldName] = 'Geçersiz bir URL formatı'
        return false
      }
    } catch (e) {
      errors[fieldName] = 'Geçersiz bir URL formatı'
      return false
    }
  }
}
